import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import _ from "lodash";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { FeatureService } from "~app/common/services/feature.service";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { FormatService } from "~app/common/services/format.service";
import { IHandelssortimentSearchParamsModel, ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { WebinstallningarService } from "../../../../common/services/webinstallningar/webinstallningar.service";
import { HandelssortimentSearchService } from "./handelssortiment-search.service";

const DEFAULT_MODEL: IHandelssortimentSearchParamsModel = {
    aktiv: true,
    aktivFormValue: "",
    beteckning: "",
    handelssortimentsgrupp: "",
    namn: "",
    ids: [],
    produktnamn: "",
    sortimentskod: "",
    sort: "-UDate",
    forProduktion: true,
    forInmatning: false
};

@Component({
    selector: "rask-search-panel",
    styleUrls: ["./search-panel.component.scss"],
    templateUrl: "./search-panel.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        CheckboxComponent,
        RadiobuttonGroupComponent,
        SubmitButtonComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class SearchPanelComponent implements OnInit {
    active = new UntypedFormControl("true");
    activetypes: IRadiobuttonItem[] = [
        { key: "true",
            value: "Ja" },
        { key: "false",
            value: "Nej" },
        { key: "",
            value: "Alla" }
    ];
    form: UntypedFormGroup;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("handelssortiment") handelssortiment = new EventEmitter<ISearchHandelssortimentModel[]>(true);

    protected handelssortimentSearchParams = _.cloneDeep(DEFAULT_MODEL);

    private readonly WIK = "Handelssortiment.searchparams";
    private readonly busyService = inject(BusyService);
    private readonly featureService = inject(FeatureService);
    private readonly formBinder = inject(FormBinderService);
    private readonly formatService = inject(FormatService);
    private readonly handelssortimentSearchService = inject(HandelssortimentSearchService);
    private readonly webinstallningarService = inject(WebinstallningarService);

    ngOnInit() {
        this.webinstallningarService.getAsync<IHandelssortimentSearchParamsModel>(this.WIK).then(x => {
            _.assign(this.handelssortimentSearchParams, _.cloneDeep(x));
            this.handelssortimentSearchParams.aktiv = this.formatService.stringToBoolean(this.handelssortimentSearchParams.aktivFormValue);
            this.form = this.formBinder.CreateGroup(this.handelssortimentSearchParams);
            this.search(false);
        });
    }

    search(saveState = true) {
        const params = _.clone(this.handelssortimentSearchParams);
        params.aktiv = this.formatService.stringToBoolean(this.handelssortimentSearchParams.aktivFormValue);
        this.busyService.addWork(this.handelssortimentSearchService.search(params)).subscribe(searchResult => {
            this.handelssortiment.emit(searchResult);
        });
        if (saveState) {
            this.webinstallningarService.set<IHandelssortimentSearchParamsModel>(this.WIK, params);
        }
    }

    protected rensaSokFilter() {
        _.assign(this.handelssortimentSearchParams, _.cloneDeep(DEFAULT_MODEL));
        this.formBinder.reBindForm(this.form, _.cloneDeep(this.handelssortimentSearchParams));
    }
}
